import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "189",
  height: "180",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFEED1",
      d: "M94.235 179.368c52.045 0 94.236-40.153 94.236-89.684S146.28 0 94.235 0C42.191 0 0 40.153 0 89.684s42.19 89.684 94.235 89.684"
    }, null, -1)
  ]))]))
}
export default { render: render }